module.exports = __webpack_public_path__ + "static/media/log_out.890ef307.svg";